/* eslint-disable no-else-return */
/* eslint-disable padding-line-between-statements */
import _ from 'lodash';
import appConfig from 'app-config';
import { MVR_ERR1, MVR_ERR2, MVR_ERR3 } from '../../override/constants/ml-mvr-constants';

const MESSAGES_ML = 'Messages_ML';
const CLOSING_SQUARE_BRACKET = ']';
const OPEN_SQUARE_BRACKET = '[';
const ERROR_805 = 'ERROR-805:';
const ERROR_803 = 'ERROR-803:';

const CDC_EXCEPTION = 'ConcurrentDataChangeException';
const CREDIT_REPORTING_DOWN_EXCEPTION = "Credit reporting is temporarily unavailable. Try again later.";
const RATING_ERROR = "A rating error has occurred while trying to generate the quote."
const MVR_ORDER_MSG = 'The Department of Motor Vehicles cannot process the Motor Vehicle report due to Invalid Name, Gender, DOB or License Number.  Please verify these fields.';
const QUOTE_REQ_INCOMPATIBLE = 'Quote request is incompatible with the existing quote, product is not available at the given date.';
const MVR_TECHNICAL_ERROR_MSG = 'Motor Vehicle Record not available at this time, please try again later.';
const SUBMISSION_NOT_FOUND = 'Submission not found';
const USER_DOES_NOT_ACCESS = 'User does not have sufficient permission to perform this task';
const DATABASE_BEAN_EXCEPTION = 'conflict';
const DATABASE_BEAN_EXCEPTION_MESSAGE = 'The System is experiencing simultaneous updates for this quote. Please wait a few seconds and continue';

const parseErrorForMessage = (errorString) => {
    const indexOfMessages = errorString.indexOf(MESSAGES_ML);
    let errorMessages = errorString.substring(indexOfMessages).split(CLOSING_SQUARE_BRACKET)[0];
    errorMessages = errorMessages.split(OPEN_SQUARE_BRACKET)[1];
    return errorMessages.replace(ERROR_803, "").replace(ERROR_805, "").trim();
};

const retrieveDisplayableErrorMessage = (error) => {
    let errorMessage;
    const baseError = error.baseError;
    if (baseError) {
        const errorMessageStringArray = baseError.split(' ');
        const outerErrorCodeIndex = baseError.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;
        if (outerErrorCodeNumericValue === appConfig.errorCodes.DISPLAYABLE_ERROR_ML) {
            errorMessage = parseErrorForMessage(baseError);
        }
    }
    return errorMessage;
};

// US963263: Generic Method to handle exceptions (currently hardcoded to handle only CDC Exception)
const handleException = (error, showErrorModal, errorMessage) => {
    if (error.baseError && error.baseError.includes(CDC_EXCEPTION)) {
        showErrorModal(null, errorMessage);
        return false;
    } else if (error.message && error.message.includes(DATABASE_BEAN_EXCEPTION)) {
        showErrorModal(null, DATABASE_BEAN_EXCEPTION_MESSAGE);
        return false;
    } else if (error.baseError && error.baseError.includes(CREDIT_REPORTING_DOWN_EXCEPTION)) {
        showErrorModal(null, CREDIT_REPORTING_DOWN_EXCEPTION);
        return false;
    } else if (error.baseError && error.baseError.includes(RATING_ERROR))  {
        showErrorModal(null, RATING_ERROR);
        return false;
    } else if (error.message && error.message.includes(CDC_EXCEPTION))  {
        showErrorModal(null, errorMessage);
        return false;
    } else if ((error.message && error.message.includes(MVR_ORDER_MSG)) 
        || (error.baseError && error.baseError.includes(MVR_ORDER_MSG)))  {
        showErrorModal(null, MVR_ORDER_MSG);
        return false;
    } else if (error.baseError && error.baseError.includes(QUOTE_REQ_INCOMPATIBLE)) {
        showErrorModal(null, QUOTE_REQ_INCOMPATIBLE);
        return false;
    } else if ((error.message && (error.message.includes(MVR_ERR1) || error.message.includes(MVR_ERR2) || error.message.includes(MVR_ERR3)  )) 
        || (error.baseError && (error.baseError.includes(MVR_ERR1) || error.baseError.includes(MVR_ERR2) || error.baseError.includes(MVR_ERR3))))  {
        showErrorModal(null, MVR_TECHNICAL_ERROR_MSG);
        return false;
    } else if (error.baseError && error.baseError.includes(SUBMISSION_NOT_FOUND)) {
        showErrorModal(null, SUBMISSION_NOT_FOUND);
        return false;
    } else if (error.baseError && error.baseError.includes(USER_DOES_NOT_ACCESS)) {
        showErrorModal(null, USER_DOES_NOT_ACCESS);
        return false;
    }
    throw error;
    
}

export default {
    retrieveDisplayableErrorMessage: retrieveDisplayableErrorMessage,
    handleException
};